export class ActionNotPermittedException extends Error {
  constructor(message = 'Action not permitted') {
    super(message);
  }
}
